import Selector from "../Selector/Selector";
import BtButton from "../../../ts-components/bt-button/bt-button";
import { ReactComponent as RefreshIcon } from "../../../assets/svg/refreshIcon.svg";
import { FC, useState } from "react";
import Loading from "../Loading";
import styles from "./NextEntityPlacementSelector.module.scss";

type Option = { label: string, value: string };

type Props = {
  value: any,
  onChange: (value: any) => void,
  options: Option[],
  onRefresh: () => void,
  loading?: boolean,
  label?: string,
  placeholder?: string,
  isCreatable?: boolean,
  errorMessage?: string,
}

const NextEntityPlacementSelector : FC<Props> = ({ value, onChange, options, onRefresh, loading, label, placeholder, isCreatable, errorMessage }) => {
  const [inputValue, setInputValue] = useState('');

  const handleChange = (v: any) => {
    setInputValue('');
    onChange(v);
  };

  // Creatable selects discard typed text on blur unless the user pressed Enter.
  // Commit whatever was typed so clicking outside keeps the value (mapping to an
  // existing option when the text matches one, otherwise keeping it as free text).
  const commitTypedValue = () => {
    if (!isCreatable) return;
    const text = inputValue.trim();
    if (!text) return;
    const match = options.find(o => o.label.toLowerCase().trim() === text.toLowerCase());
    handleChange(match ?? { label: text, value: text });
  };

  return (
    <div className={styles.container}>
      {loading && (
        <div className={styles.loadingOverlay}>
          <Loading type="inline" size="24px" />
        </div>
      )}
      <Selector
        label={label}
        placeholder={placeholder}
        options={options}
        value={value}
        onChange={handleChange}
        onInputChange={(val: string, meta: any) => { if (meta?.action === 'input-change') setInputValue(val); }}
        onBlur={commitTypedValue}
        className="add-project-field next-project-placement"
        isSearchable
        isClearable
        isCreatable={isCreatable}
        errorMessage={errorMessage}
      />
      <BtButton
        onClick={onRefresh}
        color="white"
        class="next-project-refresh"
      >
        <RefreshIcon />
      </BtButton>
    </div>
  );
}

export default NextEntityPlacementSelector;
